import "react-native-reanimated";
import { AnonymousWidgetPos } from "../types";
import { getPositionOrdinal } from "./getPositionOrdinal";
import { isHit } from "./isHit";

export function containsHit(positions: AnonymousWidgetPos[]) {
  "worklet";
  const sortedPositions = positions
    .slice()
    .sort((a, b) => getPositionOrdinal(a) - getPositionOrdinal(b));

  for (let i = 0; i < sortedPositions.length - 1; i++) {
    if (isHit(sortedPositions[i], sortedPositions[i + 1])) {
      return true;
    }
  }
  return false;
}
